/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'update';
const componentName = 'update-page';
const prefix = `${moduleName}.${componentName}`;

export const updateLabel = `${prefix}.updateLabel`;
export const segLabel = `${prefix}.segLabel`;
export const systemLabel = `${prefix}.systemLabel`;

export const ENGLISH = {
    [updateLabel]: 'Update',
    [segLabel]: 'Service Engine Groups',
    [systemLabel]: 'System',
};
